import { Compass, CalendarCheck, Sparkle, type Icon } from '@phosphor-icons/react';
import { Reveal } from '../../lib/motion';

interface Step {
  n: string;
  icon: Icon;
  title: string;
  body: string;
}

const STEPS: Step[] = [
  {
    n: '01',
    icon: Compass,
    title: 'Browse',
    body: 'Explore a curated collection of hand-picked hotels. Search a city or simply wander until something catches your eye.',
  },
  {
    n: '02',
    icon: CalendarCheck,
    title: 'Book',
    body: 'Found your place? Book in a few taps and get quick confirmation from the hotel. No queues and no surprises at the front desk.',
  },
  {
    n: '03',
    icon: Sparkle,
    title: 'Stay',
    body: 'Arrive somewhere with soul and be looked after by hosts who care. Come home with a story worth telling.',
  },
];

/**
 * "How it works" for guests — browse, enquire, stay. Three numbered steps on a
 * sage ground for a calm, editorial change of pace. No booking/payment steps.
 */
export function HowItWorks() {
  return (
    <section aria-labelledby="how-h2" className="relative grain bg-sage text-cream">
      <div className="px-6 py-20 sm:px-10 lg:px-16 lg:py-28 2xl:px-24">
        <div>
          <h2
            id="how-h2"
            className="text-balance font-serif text-[2.4rem] font-black leading-[0.98] tracking-tight sm:text-5xl xl:whitespace-nowrap"
          >
            Three steps to a better stay.
          </h2>
        </div>

        <ol className="mt-14 grid gap-10 md:grid-cols-3">
          {STEPS.map(({ n, icon: Icon, title, body }, i) => (
            <Reveal as="li" key={n} delay={i * 130} className="border-t border-cream/25 pt-6">
              <div className="flex items-center justify-between">
                <span className="font-serif text-5xl font-semibold text-cream/40">{n}</span>
                <Icon className="h-7 w-7 text-cream/80" aria-hidden="true" />
              </div>
              <h3 className="mt-5 font-serif text-2xl font-semibold">{title}</h3>
              <p className="mt-2.5 text-[15px] leading-relaxed text-cream/85">{body}</p>
            </Reveal>
          ))}
        </ol>
      </div>
    </section>
  );
}
